module.exports = __webpack_public_path__ + "static/media/apploader-black.ebf0fc1d.gif";